import Honeybadger from '@honeybadger-io/js';

export default class HoneybadgerLogger {
  init() {
    Honeybadger.configure({
      api_key: `${gon.honeybadger_api_key}`,
      environment: 'production',
      max_depth: 2
    });
  }
}
